import Vue from 'vue';
import Vuex from 'vuex';
import mutations from '@/mutations';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		apiBaseUrl: null,
		actionHint: null,
		alert: {
			message: null,
			type: null,
			displayTime: 0
		}
	},
	getters: {
		apiBaseUrl(state) {
			return state.apiBaseUrl;
		},
		actionHint(state) {
			return state.actionHint;
		}
	},
	mutations: {
		[mutations.updateApiBaseUrl] (state, newApiBasUrl: string) {
			state.apiBaseUrl = newApiBasUrl;
		},
		[mutations.updateActionHint] (state, newActionHint: string) {
			state.actionHint = newActionHint;
		}
	},
	actions: {
		resetActionHint(context) {
			context.commit(mutations.updateActionHint, '');
		}
	}
});
